var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8989 12.9423C38.9922 19.3224 35.9241 27.5972 29.472 32.8132C23.0198 38.0291 15.6269 38.211 10.5336 31.8309C5.44035 25.4508 -0.636244 16.4225 5.8159 11.2065C12.268 5.99056 28.8056 6.56214 33.8989 12.9423Z",
    fill: "#EEF0FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26.8635,
    width: 24,
    height: 4.18182,
    rx: 2.09091,
    stroke: "#1E3269",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2726 31.0454V31.0454C24.2726 32.7776 22.8684 34.1818 21.1362 34.1818L20.8635 34.1818C19.1313 34.1818 17.7271 32.7776 17.7271 31.0454V31.0454L24.2726 31.0454Z",
    stroke: "#1E3269",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8183 10.1364L18.8183 9.18181C18.8183 7.97682 19.7951 6.99999 21.0001 6.99999V6.99999C22.2051 6.99999 23.1819 7.97682 23.1819 9.18181L23.1819 10.1364L18.8183 10.1364Z",
    stroke: "#1E3269",
    strokeWidth: 1.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 10.1364C25.8201 10.1364 29.7274 14.0437 29.7274 18.8636L29.7274 26.8636L12.2729 26.8636L12.2729 18.8636C12.2729 14.0437 16.1802 10.1364 21.0001 10.1364V10.1364Z",
    stroke: "#1E3269",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4346 13.678C18.0247 13.678 16.071 15.5502 16.071 17.8598",
    stroke: "#1E3269",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.b7ee67da6fddc9590b3dae310cd947c0.svg";
export { ForwardRef as ReactComponent };